import * as TypeGraphQL from "type-graphql";
export var AlertScalarFieldEnum;
(function (AlertScalarFieldEnum) {
    AlertScalarFieldEnum["id"] = "id";
    AlertScalarFieldEnum["alpacaAccountId"] = "alpacaAccountId";
    AlertScalarFieldEnum["title"] = "title";
    AlertScalarFieldEnum["message"] = "message";
    AlertScalarFieldEnum["type"] = "type";
    AlertScalarFieldEnum["severity"] = "severity";
    AlertScalarFieldEnum["category"] = "category";
    AlertScalarFieldEnum["status"] = "status";
    AlertScalarFieldEnum["isRead"] = "isRead";
    AlertScalarFieldEnum["acknowledgedAt"] = "acknowledgedAt";
    AlertScalarFieldEnum["resolvedAt"] = "resolvedAt";
    AlertScalarFieldEnum["suppressedUntil"] = "suppressedUntil";
    AlertScalarFieldEnum["retryCount"] = "retryCount";
    AlertScalarFieldEnum["metadata"] = "metadata";
    AlertScalarFieldEnum["createdAt"] = "createdAt";
    AlertScalarFieldEnum["updatedAt"] = "updatedAt";
})(AlertScalarFieldEnum || (AlertScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(AlertScalarFieldEnum, {
    name: "AlertScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=AlertScalarFieldEnum.js.map